module.exports = __webpack_public_path__ + "img/bottom_highlight.23881ff0.png";